import React, { useState } from 'react';
import './chartCard.scss';

interface ChartCardProps {
  title: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  initiallyCollapsed?: boolean;
}

const ChartCard: React.FC<ChartCardProps> = ({
  title,
  icon,
  children,
  initiallyCollapsed = false,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(initiallyCollapsed);

  return (
    <div className="chart-card">
      <div className="chart-card__header">
        <div className="chart-card__title-container">
          {icon && <div className="chart-card__icon">{icon}</div>}
          <h2 className="chart-card__title">{title}</h2>
        </div>
        <button
          className="chart-card__toggle"
          onClick={() => setIsCollapsed((prev) => !prev)}
          aria-label={isCollapsed ? 'Expand' : 'Collapse'}
        >
          {isCollapsed ? '▼' : '▲'}
        </button>
      </div>

      {!isCollapsed && <div className="chart-card__body">{children}</div>}
    </div>
  );
};

export default ChartCard;